























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import MarketsTemplate from '@/components/templates/MarketsTemplate/index.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';
import DpInput from '@/components/atoms/DpInput/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import PerformanceRegion from '@/components/organisms/MarketRegion/PerformanceRegion/index.vue';
import DpIconButton from '@/components/atoms/DpIconButton/index.vue';
import ApplicationActionTypes from '@/modules/application/ApplicationActionTypes';
import PerformanceActionTypes from '@/modules/performance/PerformanceActionTypes';
import PerformanceService from '@/modules/performance/services/PerformanceService';
import MarketRegionSubscribe from '@/components/organisms/MarketRegion/Subscribe/index.vue';
import DpAddToFavorite from '@/components/molecules/DpAddToFavorite/index.vue';
import SubscriberActionTypes from '@/modules/subscriber/SubscriberActionTypes';
import MarketRegionOtherMetrics from '@/components/organisms/MarketRegion/MarketRegionOtherMetrics/index.vue';
import MarketRegionQuestions from '@/components/organisms/MarketRegion/MarketRegionQuestions/index.vue';
import MarketRegionSeo from '@/components/organisms/MarketRegion/MarketRegionSeo/index.vue';

@Component({
  name: 'MarketRegion',
  components: {
    DpAddToFavorite,
    SvgIcon,
    MarketsTemplate,
    DpInput,
    DpButton,
    PerformanceRegion,
    DpIconButton,
    MarketRegionSubscribe,
    MarketRegionOtherMetrics,
    MarketRegionQuestions,
    MarketRegionSeo,
  },
})
export default class MarketRegion extends Vue {
  protected isFavorite: any = false;

  protected widgetTypes: any = PerformanceService.WIDGET_TYPES;

  @Getter('favoriteMarkets', { namespace: 'subscriber' })
  protected favoriteMarkets!: any;

  @Getter('regionWidgets', { namespace: 'performance' })
  protected regionWidgets: any;

  @Getter('isAuthenticated', { namespace: 'auth' })
  protected isAuthenticated!: boolean;

  @Action(ApplicationActionTypes.PUSH_ROUTE, { namespace: 'application' })
  protected dispatchPushRoute: any;

  @Action(PerformanceActionTypes.CLEAR_REGION_WIDGETS, { namespace: 'performance' })
  protected dispatchClearRegionWidgets!: any;

  @Action(PerformanceActionTypes.LOAD_REGION_WIDGETS, { namespace: 'performance' })
  protected dispatchGetRegionWidgets!: any;

  @Action(ApplicationActionTypes.PRERENDER_READY, { namespace: 'application' })
  protected dispatchPrerenderReady!: any;

  @Action(SubscriberActionTypes.ADD_MARKET_TO_FAVORITE, { namespace: 'subscriber' })
  protected dispatchAddMarketToFavorite!: any;

  @Action(SubscriberActionTypes.REMOVE_MARKET_FROM_FAVORITE, { namespace: 'subscriber' })
  protected dispatchRemoveMarketFromFavorite!: any;

  @Action(SubscriberActionTypes.LOAD_MARKETS_FAVORITES, { namespace: 'subscriber' })
  protected dispatchLoadMarketsFavorites!: any;

  protected onClickBack = () => {
    window.location.href = '/markets/';
  };

  protected get title() {
    if (this.regionWidgets && this.regionWidgets[this.widgetTypes.REGION_MARKET_NAME]) {
      return this.regionWidgets[this.widgetTypes.REGION_MARKET_NAME];
    }
    return '';
  }

  protected get marketNeighbours() {
    if (!this.regionWidgets || !this.regionWidgets[this.widgetTypes.REGION_NEIGHBOURS]) {
      return null;
    }
    return this.regionWidgets[this.widgetTypes.REGION_NEIGHBOURS];
  }

  protected get marketUri() {
    const { regionUri } = this.$route.params;
    return regionUri;
  }

  protected get marketRegionSeoData() {
    if ((window as any).__PRERENDER_INJECTED) {
      return null;
    }
    const { regionUri } = this.$route.params;
    try {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return require(`@/../public/market-seo-text/${regionUri}.json`);
    } catch (e) {
      return null;
    }
  }

  @Watch('isAuthenticated', { immediate: true })
  protected onChangeIsAuthenticated() {
    if (this.isAuthenticated) {
      this.dispatchLoadMarketsFavorites();
    }
  }

  @Watch('$route.params', { immediate: true, deep: true })
  protected async onRouteParamsChange() {
    const { regionUri } = this.$route.params;
    /* eslint no-underscore-dangle: 0 */
    if ((window as any).__PRERENDER_INJECTED) {
      this.dispatchPrerenderReady();
      return;
    }
    if (regionUri) {
      this.dispatchClearRegionWidgets();
      this.dispatchGetRegionWidgets({
        widgetTypes: [
          this.widgetTypes.REGION_MARKET_NAME,
        ],
        regionUri,
      });
      this.dispatchGetRegionWidgets({
        widgetTypes: [
          this.widgetTypes.REGION_MARKET_SUPPLY,
          this.widgetTypes.REGION_AVERAGE_RATE,
          this.widgetTypes.REGION_MIN_NIGHT_STAY,
          this.widgetTypes.REGION_OCCUPANCY_RATE,
          this.widgetTypes.REGION_DAY_OF_THE_WEEK_OCCUPANCY,
          this.widgetTypes.REGION_DAY_OF_THE_WEEK_PRICE_FACTOR,
          this.widgetTypes.REGION_NEIGHBOURS,
        ],
        regionUri,
      });
      this.dispatchGetRegionWidgets({
        widgetTypes: [
          this.widgetTypes.REGION_MAP,
          this.widgetTypes.REGION_POLYGON,
        ],
        regionUri,
      });
      this.dispatchGetRegionWidgets({
        widgetTypes: [
          this.widgetTypes.MARKET_SUPPLY_TYPE_OF_PLACE,
        ],
        regionUri,
      });
    }
  }

  @Watch('favoriteMarkets', { immediate: true, deep: true })
  protected onChangeFavoriteMarkets() {
    if (this.favoriteMarkets) {
      const market = this.favoriteMarkets.find((item: any) => item.marketUri === this.marketUri);
      if (market) {
        this.isFavorite = true;
      }
    }
  }

  protected onChangeFavorite(value: any) {
    this.isFavorite = value;
    const separateIndex = this.title.indexOf(', ');
    const title = this.title.substring(0, separateIndex);
    const location = this.title.substring(separateIndex + 2, this.title.length);
    if (value) {
      this.dispatchAddMarketToFavorite({
        uri: this.marketUri,
        location,
        title,
      });
    } else {
      this.dispatchRemoveMarketFromFavorite({
        uri: this.marketUri,
      });
    }
  }
}
